/*
 * @author bai <ghimping@alpstein.my>
 * @link https://www.alpstein.my
 * @copyright Copyright (c) Alpstein Software
 *            _____                    _____                    _____
 *           /\    \                  /\    \                  /\    \
 *          /::\    \                /::\    \                /::\    \
 *         /::::\    \              /::::\    \               \:::\    \
 *        /::::::\    \            /::::::\    \               \:::\    \
 *       /:::/\:::\    \          /:::/\:::\    \               \:::\    \
 *      /:::/__\:::\    \        /:::/__\:::\    \               \:::\    \
 *     /::::\   \:::\    \      /::::\   \:::\    \              /::::\    \
 *    /::::::\   \:::\    \    /::::::\   \:::\    \    ____    /::::::\    \
 *   /:::/\:::\   \:::\ ___\  /:::/\:::\   \:::\    \  /\   \  /:::/\:::\    \
 *  /:::/__\:::\   \:::|    |/:::/  \:::\   \:::\____\/::\   \/:::/  \:::\____\
 *  \:::\   \:::\  /:::|____|\::/    \:::\  /:::/    /\:::\  /:::/    \::/    /
 *   \:::\   \:::\/:::/    /  \/____/ \:::\/:::/    /  \:::\/:::/    / \/____/
 *    \:::\   \::::::/    /            \::::::/    /    \::::::/    /
 *     \:::\   \::::/    /              \::::/    /      \::::/____/
 *      \:::\  /:::/    /               /:::/    /        \:::\    \
 *       \:::\/:::/    /               /:::/    /          \:::\    \
 *        \::::::/    /               /:::/    /            \:::\    \
 *         \::::/    /               /:::/    /              \:::\____\
 *          \::/____/                \::/    /                \::/    /
 *           ~~                       \/____/                  \/____/
 *
 */

import React from "react";
import { Component } from "react";
import connect from "react-redux/es/connect/connect";
import styled from "styled-components";
import PropTypes from "prop-types";
import { BeatLoader } from "react-spinners";
import * as _ from "underscore";
import LoadingIndicator from "../../components/LoadingIndicator";
import SearchListing from "../../components/SearchListing";
import SearchBar from "../../components/SearchBar";
import EmptySearch from "../../components/EmptySearch";
import EmptyKeyword from "../../components/EmptyKeyword";
import * as selectors from "../../selectors";
import * as searchAction from "../../actions/search";
import * as searchSelectors from "../../selectors/search";

const StyledContainer = styled.div`
  background: #f4f4f4;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

class SearchPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      animationClass: null,
      currentKeyword: ""
    };
  }

  componentDidMount() {
    this.setState({ animationClass: "slide-in-right" });
    this.configureNavBar();
  }

  configureNavBar = () => {
    const { navbarConfig, showTabbar, showNavbar } = this.props;

    navbarConfig(
      <SearchBar changeListener={this.onTextChange} />,
      null,
      null,
      () => this.onBackPressed(),
      null
    );
    showNavbar(true);
    showTabbar(false);
  };

  getResultBoxContent = () => {
    const { currentKeyword } = this.state;
    const { searchResult, loading } = this.props;
    const searchResultFoodItems =
      searchResult && searchResult[currentKeyword]
        ? searchSelectors.getSearchDataFoodItems(searchResult[currentKeyword])
        : null;

    if (loading) {
      return (
        <LoadingIndicator indicator={<BeatLoader size={12} color="gray" />} />
      );
    }

    if (currentKeyword.length === 0) {
      return <EmptyKeyword />;
    }

    if (!!searchResultFoodItems && _.isEmpty(searchResultFoodItems)) {
      return <EmptySearch />;
    }

    if (!!searchResultFoodItems && !_.isEmpty(searchResultFoodItems)) {
      return (
        <SearchListing
          items={searchResultFoodItems}
          onItemClicked={this.onItemClicked}
        />
      );
    }

    return <EmptyKeyword typing />;
  };

  onItemClicked = (foodId, searchQuery) => {
    const { history, putSearchQueryToken } = this.props;

    putSearchQueryToken(searchQuery);
    history.push(`/shop/product/${foodId}`);
  };

  onTextChange = keyword => {
    this.setState({ currentKeyword: keyword });
  };

  onBackPressed = () => {
    const { history } = this.props;
    this.setState({ animationClass: "slide-out-right" });

    window.setTimeout(() => {
      history.goBack();
    }, 300);
  };

  render() {
    const { animationClass } = this.state;

    return (
      <StyledContainer
        className={animationClass !== null ? animationClass : false}
        onAnimationEnd={() => this.setState({ animationClass: null })}
      >
        {this.getResultBoxContent()}
      </StyledContainer>
    );
  }
}

SearchPage.propTypes = {
  intl: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  showNavbar: PropTypes.func.isRequired,
  showTabbar: PropTypes.func.isRequired,
  navbarConfig: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  searchResult: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  putSearchQueryToken: PropTypes.func
};

function mapStateToProps(state) {
  return {
    loading: selectors.getSearchLoading(state),
    searchResult: selectors.getSearchResult(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    putSearchQueryToken: query =>
      dispatch(searchAction.putSearchQueryTokenRequest(query))
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SearchPage);



// WEBPACK FOOTER //
// ./src/containers/SearchPage/index.js